import { render } from "./CategorySorts.vue?vue&type=template&id=3fe77007&scoped=true"
import script from "./CategorySorts.vue?vue&type=script&lang=js"
export * from "./CategorySorts.vue?vue&type=script&lang=js"

import "./CategorySorts.vue?vue&type=style&index=0&id=3fe77007&lang=scss&scoped=true"
import "./CategorySorts.vue?vue&type=style&index=1&id=3fe77007&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe77007"]])

export default __exports__